// extracted by mini-css-extract-plugin
export var button = "_d1-0";
export var donut = "_d1-1";
export var donutFill = "_d1-3";
export var donutTrack = "_d1-2";